import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useUpdateParticipantStatusMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IScheduledMeeting) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({
			meetingId,
			participantId,
			status,
			forUserId,
		}: {
			meetingId: string;
			participantId: string;
			status: Api.InvitationStatus;
			forUserId?: string;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IScheduledMeeting>(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: { forUserId },
					urlPath: `ScheduledMeeting/${meetingId}/participant/${participantId}/status`,
				}),
				'PUT',
				{ status }
			);
		},
		onSuccess,
		onError,
	});
}
